export const WITHDRAWAL_NETWORK_TYPES = {
    BITCOIN: 'BITCOIN',
    ETHEREUM: 'ETHEREUM',
    LITECOIN: 'LITECOIN',
    LIGHTNING: 'LIGHTNING',
    STELLAR: 'STELLAR',
    CBU: 'CBU/CVU',
    PIX: 'PIX',
}